import { z } from "zod";
/**
 * Clientes de exemplo da homologacao (spec 055): as vendas de um lote, que o backend manda pro `pagamentos` pela rota
 * interna assinada (`POST /v1/interno/exemplos/vendas`). Viram historico em Vendas; nao geram evento de volta.
 */
export const VendaDeExemplo = z.object({
    codigo: z.string().trim().min(6).max(80),
    status: z.enum(["PAGO", "AGUARDANDO", "RECUSADO", "EXPIRADO", "REEMBOLSADO"]),
    nome: z.string().trim().min(2).max(200),
    cpf: z.string().regex(/^\d{11}$/),
    email: z.string().trim().email().max(200),
    telefone: z.string().trim().max(20),
    plano_slug: z.string().trim().min(1).max(80),
    plano_nome: z.string().trim().min(1).max(200),
    plataforma: z.enum(["PROFIT_ONE", "PROFIT_PRO"]).nullable(),
    valor_centavos: z.number().int().positive().max(10_000_000),
    meio: z.enum(["PIX", "CARTAO"]),
    parcelas: z.number().int().min(1).max(12),
    criado_em: z.string().datetime(),
    pago_em: z.string().datetime().nullable(),
    cartao_final: z.string().regex(/^\d{4}$/).nullable(),
    pix_e2e: z.string().max(40).nullable(),
    recusa: z.string().max(200).nullable(),
});
export const VendasDeExemplo = z.object({ vendas: z.array(VendaDeExemplo).min(1).max(100) });
//# sourceMappingURL=exemplos.js.map